module.exports = __webpack_public_path__ + "img/RGX.a19f0a1c.png";